"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { readAnalyticsConsent } from "@/components/analytics/browser-attribution";
import { subscribeToBrowserConsentCategory } from "@/components/analytics/browser-consent-lifecycle";
import { POSTHOG_BROWSER_INITIALIZED_EVENT } from "@/lib/analytics/posthog-browser-lifecycle";

export function WebVitalsCapture() {
  useEffect(() => {
    let cancelled = false;
    let registrationStarted = false;
    let registered = false;

    function registerWhenReady() {
      if (
        registrationStarted ||
        registered ||
        !posthog.__loaded ||
        readAnalyticsConsent() !== "accepted"
      ) {
        return;
      }
      registrationStarted = true;

      void import("web-vitals").then(({ onLCP, onINP, onCLS }) => {
        if (cancelled) return;
        if (!posthog.__loaded || readAnalyticsConsent() !== "accepted") {
          registrationStarted = false;
          return;
        }
        registered = true;

        function sendMetric(metric: {
          name: string;
          value: number;
          rating: string;
        }) {
          if (!posthog.__loaded || readAnalyticsConsent() !== "accepted") {
            return;
          }
          posthog.capture("$web_vitals", {
            metric: metric.name,
            value: metric.value,
            rating: metric.rating,
          });
        }

        onLCP(sendMetric);
        onINP(sendMetric);
        onCLS(sendMetric);
      });
    }

    registerWhenReady();
    window.addEventListener(
      POSTHOG_BROWSER_INITIALIZED_EVENT,
      registerWhenReady,
    );
    const unsubscribeConsent = subscribeToBrowserConsentCategory(
      "analytics",
      registerWhenReady,
    );
    return () => {
      cancelled = true;
      window.removeEventListener(
        POSTHOG_BROWSER_INITIALIZED_EVENT,
        registerWhenReady,
      );
      unsubscribeConsent();
    };
  }, []);

  return null;
}
